import dnsLookup from '../modules/dns-lookup';
import _ from 'lodash.escape';

const lookup = (lookupInstance, lookupType, onFailed) => {
    lookupInstance.getLookup(lookupType, function (result, records) {
        try {
        let status = $('#' + lookupType + '-status');
        let content = status.data('content');

        status.addClass(content[result].class);
        status.text(content[result].label);

        $('#' + lookupType + '-content').html(records.map((value, index) => {
            return '<div>' + _(value) + '</div>';
        }));

        if (typeof onFailed !== 'undefined' && result === 'notValid') {
            onFailed();
        }

        } catch (e) {
            console.log('Error in lookup', e);
        }
    });
}

const initialize = () => {
    const dnsLookupInstance = new dnsLookup();

    lookup(dnsLookupInstance, 'mx');
    lookup(dnsLookupInstance, 'txt');
    lookup(dnsLookupInstance, 'mailcname');
    lookup(dnsLookupInstance, 'txt_dmarc');
    lookup(dnsLookupInstance, 'cname_dkim', () => document.querySelector('#dkim_error_alert').style.display = 'flex');
    lookup(dnsLookupInstance, 'srv');
};

export default initialize;
